import React, { useState, useEffect } from "react";
import { fetchCollection } from "../../cockpit/fetch";
import { useParams } from "react-router-dom";
import './Project.scss';
import Page404 from "../Page/404";
import * as Config from '../../config';
import { useTransactions } from "../../hooks/useTransactions";

const Projects = () => {
    const [page, setPage] = useState(null);
    const [transactionTotals, setTransactionTotals] = useState<Record<string, number> | null>(null);
    const { getProjectsTransactions } = useTransactions();

    const { slug } = useParams();

    useEffect(() => {
        let isCancelled = false;
        fetchCollection('project').then((data) => {
            if (!isCancelled) {
                setPage(data.data);
            }
        });
        return () => {
            isCancelled = true;
        }
    }, [slug])

    useEffect(() => {
        let isCancelled = false;

        getProjectsTransactions().then(res => {
            if (!isCancelled) {
                setTransactionTotals(res.data || {});
            }
        }).catch(err => {
            if (!isCancelled) {
                console.error(err);
                setTransactionTotals({});
            }
        });

        return () => {
            isCancelled = true;
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return <>
        {page && <>
            {page === 'error' ? <Page404 /> :
                <div className={`sec-pad thm-container Projects`}>
                    <h1>Projects</h1>
                    <div className="projects-list">
                        {!page.entries ? <p>No projects found.</p> : page.entries.map((project) => (
                            <div key={project._id} className={`project-card project-${project.title.toLowerCase()}`}>
                                <img src={Config.COCKPIT_HOST + project.main_photo.path} alt={project.title} className="project-image" />
                                <h2>{project.title}</h2>
                                <div className="metadata">
                                    <p className="project-id">{project.project_id}</p>
                                    <p className="project-deadline">Deadline: {new Date(project.deadline).toLocaleDateString()}</p>
                                </div>
                                <div className="project-stats">
                                    <div className="stat-box">
                                        <span className="stat-label">Target</span>
                                        <span className="stat-value">${parseInt(project.target).toLocaleString()}</span>
                                    </div>
                                    <div className="stat-box">
                                        <span className="stat-label">Funded</span>
                                        <span className="stat-value">
                                            {transactionTotals !== null ? `${Math.round(((Number(project.current_balance || 0) + (Number(transactionTotals[project.project_id] || 0))) / Number(project.target || 1)) * 100)}%` : 'Loading...'}
                                        </span>
                                    </div>
                                    <div className="stat-box">
                                        <span className="stat-label">ROI</span>
                                        <span className="stat-value">{project.roi}%</span>
                                    </div>
                                </div>
                                <a href={`/project/${project.title_slug}`} className="view-details">View Details</a>
                            </div>
                        ))}
                    </div>
                </div>
            }</>
        }
    </>
}
export default Projects;